import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import Pagination from 'reactjs-hooks-pagination';
import { Form, Tab, Tabs } from 'react-bootstrap';

import Breadcrumb from '../../components/Breadcrumb';
import { updateThresholdCredit, userListService, updateShowCredit } from '../../services/userService';
import { Loader } from '../../components/util/Svg';
import { getCouponById, updateTax, updateUserCoupon } from "../../services/couponService";
import LastActive from "../../components/util/LastActive";

const Users = () => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [thresholdValue, setThresholdValue] = useState();
    const [thresholdValueErr, setThresholdValueErr] = useState();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [thresHoldStatus, setThresHoldStatus] = useState(1);

    const [search, setSearch] = useState('');
    const [type, setType] = useState(0);

    const [filterBy, setFilterBy] = useState('');
    const [currentId, setCurrentId] = useState('');
    const [couponOff, setCouponOff] = useState('');
    const [percentOff, setPercentOff] = useState('');
    const [couponId, setCouponId] = useState('');
    const [email, setEmail] = useState('');
    const [couponIdErr, setCouponIdErr] = useState('');
    const [couponSuccess, setCouponSuccess] = useState('');
    const [isDisabled, setIsDisabled] = useState('');
    const [createModal, setCreateModal] = useState('');
    const [editType, setEditType] = useState(false);
    const [pagination, setPagination] = useState('');
    const [defaultTab, setDefaultTab] = useState(1);
    const [isActiveSubscriber, setIsActiveSubscriber] = useState(0);

    const breadcrumb = [
        { link: '', linkText: 'Users' }
    ]

    const handleSearch = (e) => {
        //console.log(e.target.value, "kjhgfdsdfghjuikol")
        setSearch(e.target.value)
        let params = `?page=${page}&limit=${limit}&search=${e.target.value}`;
        userListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.userList);
                setPagination({
                    totalCount: res.data.totalCount,
                    currentPage: res.data.currentPage,
                    pageSize: res.data.pageSize,
                    totalPages: res.data.totalPages,
                })
            }
        })

    }

    const getList = () => {
        let params = `?page=${page}&limit=${limit}&search=${search}&type=${type}&filterBy=${filterBy}`;
        userListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.userList);
                setPagination({
                    totalCount: res.data.totalCount,
                    currentPage: res.data.currentPage,
                    pageSize: res.data.pageSize,
                    totalPages: res.data.totalPages,
                })
            }
        })
    }


    const handlePageChange = val => {
        setPage(val)
    }

    useEffect(() => {
        getList();
    }, [page, type, filterBy]);

    const handleSelect = (e, userId, type, threshold) => {
        // setIsDisabled(true);

        //console.log(threshold, userId, type, "kjhgghjkl;")
        setThresholdValueErr('')


        let params = {}
        if (type == 1) {
            params = {
                'type': 3,
                'thresholdValue': e.target.value,
                'usrId': userId
                // 'packId': creditPackId
            }
        }
        else if (type == 4) {
            params = {
                'type': 4,
                'isActiveSubscriber': threshold == 0 ? 1 : 0,
                'usrId': userId
                // 'packId': creditPackId
            }
        }
        else if (type === 5) {  // Case for showCredit
            params = {
                'custId': userId,
                'showCredit': !threshold  // Simply toggle the boolean value
            };
        }
        else {
            params = {
                'type': 2,
                'thresholdRefill': threshold == 1 ? 2 : 1,
                'usrId': userId

            }
        }



        let _service = (type === 5) ? updateShowCredit : updateThresholdCredit;


        _service(params).then(res => {
            if (res.status) {

                getList();
            }
        })


    }
    const handleClose = () => {
        setCreateModal(false);
        setCouponId();
        setCouponIdErr();
        setCurrentId('');
        setEmail('');
        setEditType(false)
        setEditType(false)
    }

    const handleEdit = (item, type) => {
        setCreateModal(true);
        setCouponId(item.couponId);
        setEmail(item.email);
        setCurrentId(item._id);//userId
    }
    const handleValidate = () => {
        let validate = true;
        // if (couponId == '' || couponId == undefined) {
        //     setCouponIdErr('Coupon name is required');
        //     validate = false
        // }

        // if (percentOff == '' || percentOff == null || percentOff == undefined) {
        //     validate = false
        //
        // }


        return validate;
    }

    const handleOnChange = (e,) => {
        setCouponIdErr('')
        setCouponSuccess('')
        setPercentOff('')
        console.log("fffffffffffff", currentId, e.target.value)

        setCouponId(e.target.value);
        // let couponId=e.target.value
        let params = `?couponId=${e.target.value}`;

        if (e.target.value) {
            getCouponById(params).then(res => {
                if (res.status) {

                    console.log(res.data.list, "dfffffffffffffxcccccccccc")
                    console.log(res, "sasdfdsddsffffffffffffffxcccccccccc")

                    if (res.data.list.errors && res.data.list.errors.raw.message) {
                        setCouponIdErr(res.data.list.errors.raw.message)
                    } else {

                        if (!res.data.list.valid) {
                            setCouponIdErr("This coupon code is expired.")

                        }
                        else {
                            console.log(res.data.list, "nbvbnbvdfffffffffffffxcccccccccc")




                            if (!_.isEmpty(res.data.list.metadata && res.data.list.metadata.emails)) {
                                // setCouponIdErr(res.data.list.metadata.emails)
                                console.log(res.data.list, "1nbvbnbvdfffffffffffffxcccccccccc")

                                let emails = (res.data.list.metadata.emails)
                                emails = emails.split(",")
                                var n = emails.includes(email);

                                console.log(n, "fffffffffffffffffffsfds")
                                if (n) {
                                    setCouponSuccess("Code is applied")
                                    setPercentOff(res.data.list.percent_off)
                                } else {
                                    setPercentOff('')
                                    setCouponSuccess('')
                                    setCouponIdErr("This coupon code is not valid for you")
                                }
                            } else {
                                console.log(res.data.list, "2nbvbnbvdfffffffffffffxcccccccccc")
                                setCouponSuccess("Code is applied")

                                setPercentOff(res.data.list.percent_off)


                            }
                        }
                    }

                }
            })
        }
    }
    const handleSubmit = e => {
        e.preventDefault();
        if (handleValidate()) {
            setIsDisabled(true);
            let params = {};
            // if (currentId) {            }
            if (currentId) {

                params = {

                    'percentOff': percentOff ? percentOff : 0,
                    'couponId': couponId ? couponId : '',
                    'usrId': currentId ? currentId : '',
                    'showCoupon': couponId ? 2 : 1,

                }
            }


            updateUserCoupon(params).then(res => {
                setEditType(false)
                setCurrentId('')
                setIsDisabled(false);
                if (res.status) {
                    handleClose();
                    getList();
                }
            })
        }

    }
    const handleChangeTax = (e, userId) => {
        console.log(e.target.value, userId, "fccccccccccccccccc")
        let params = {};

        params = {

            'taxStatus': e.target.value ? e.target.value : '',
            'usrId': userId ? userId : '',

        }



        updateTax(params).then(res => {
            if (res.status) {
                getList();
            }
        })


    }

    const getTabValue = (e) => {
        setDefaultTab(e);
        if (e == 2) {
            setType(1)
        } else if (e == 1) {
            setType(0)
        }
    }

    const handleFilterChange = (field) => {
        // Set new field and reset to ascending
        setFilterBy(field);
    };

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <input
                    type="text"
                    maxLength={"35"}
                    className="form-control"
                    value={search}
                    onChange={handleSearch}
                    placeholder="Search" />                <i className="fa fa-search barsearch" />

                <span className="btn btn-primary btn-sm"
                >Search </span>
            </div>

            <Breadcrumb breadcrumb={breadcrumb} />

            <div className="d-flex justify-content-between align-content-center page_header">
                <h2>Users List</h2>
                {/* <div>
                    <Dropdown>
                        <Dropdown.Toggle className="no_btn"><i className="fa fa-sliders" /></Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1">All</Dropdown.Item>
                            <Dropdown.Item href="#/action-1">Active</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">InActive</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">Panding</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">Canceled</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div> */}
            </div>
            <div className="">

                <div className="px-lg-4 pt-3 pb-md-5 pb-4">

                    <Tabs
                        defaultActiveKey="1"
                        activeKey={defaultTab}
                        onSelect={(e) => getTabValue(e)}
                        className="breadcrumb-account nav-sticky"
                    >
                        <Tab eventKey="1" title={('All')}>
                            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                                {loader ? <div className="loader_lg"><Loader /></div> : ''}
                                <table className="table user-table table-hover align-items-center">
                                    <col style={{ width: '3%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '17%' }} />
                                    <col style={{ width: '10%' }} />
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Name</th>
                                            <th onClick={() => handleFilterChange('created')} style={{ cursor: 'pointer' }}>
                                                Created {filterBy === 'created'}
                                            </th>
                                            <th>Company name</th>
                                            <th>Credits left</th>
                                            <th>Auto refill</th>
                                            <th>Show Credit</th>
                                            <th>Active Subscribers</th>
                                            <th>⁠Subscription Plan</th>
                                            <th>Mobile number</th>
                                            <th onClick={() => handleFilterChange('lastActive')} style={{ cursor: 'pointer' }}>
                                                Last Active {filterBy === 'lastActive'}
                                            </th> 
                                            <th>Cars created</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((item, i) => (
                                            <tr key={item._id}>
                                                <td>{((i + 1) + ((page - 1) * limit))}</td>
                                                <td>
                                                    <Link to={`/userdetail/${item._id}`}>
                                                        <div className="d-inline-block align-middle">
                                                            <span className="font-weight-bold">{item.fullName}</span>
                                                            <div className="small text-gray">{item.email}</div>
                                                        </div>
                                                    </Link>
                                                </td>
                                                <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                                                {item.companyDetails ? <td>{item.companyDetails.companyName}</td> : item.companyName ?
                                                    <td>{item.companyName}</td> : <td>-</td>}
                                                {/* {item.companyDetails ?
                                                    <td>{item.companyDetails.suit}, {item.companyDetails.streetAddress}, {item.companyDetails.city}, {item.companyDetails.state}, {item.companyDetails.country} ({item.companyDetails.postalCode})</td> :
                                                    <td>-</td>} */}
                                                <td>{item.leftPackCredits ? item.leftPackCredits : 0}</td>

                                                <td><label class="switch">


                                                    <input type="checkbox" checked={item.thresholdRefillStatus == 1 ? true : false}
                                                        onChange={(e) => handleSelect(e, item._id, 2, item.thresholdRefillStatus)} />
                                                    <span class="slider round"></span>
                                                </label></td>



                                                {/* added this ui */}
                                                {/* added this ui */}
                                                <td>
                                                    <label className="switch">

                                                        <input
                                                            type="checkbox"
                                                            checked={item.showCredit === true}  // Changed this line
                                                            onChange={(e) => handleSelect(e, item._id, 5, item.showCredit)}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                </td>

                                                <td><label class="switch">


                                                    <input type="checkbox" checked={item.isActiveSubscriber == 1 ? true : false} onChange={(e) => handleSelect(e, item._id, 4, item.isActiveSubscriber)} />
                                                    <span class="slider round"></span> </label></td>
                                                <td>{item.subscriptionPlan ? item.subscriptionPlan : ''}</td>
                                                <td>{item.countryCode ? item.countryCode : ''} {item.phone ? item.phone : ''}</td>

                                                <td>
                                                    {item.lastActive ? <LastActive timestamp={item.lastActive} /> : ''}
                                                </td>
                                                {/*
                                                <td>
                                                    {item.couponId ? item.couponId : ' ADD   '}
                                                    {item.couponId ?
                                                        <i onClick={() => handleEdit(item)} className="fa fa-pencil cursorpointer" /> :
                                                        <i onClick={() => handleEdit(item)} className="fa fa-plus cursorpointer" />}
                                                </td> */}


                                                <td>{item.carCount}</td>
                                                {/*
                                                <td>

                                                    <select
                                                        defaultValue={item.taxStatus}
                                                        onChange={e => (handleChangeTax(e, item._id))}
                                                        className={`form-control rounded-pill rounded`}>

                                                        
                                                        <option value="1">Taxable</option>
                                                        <option value="2">Exempt</option>
                                                        <option value="3">Reverse charge</option>
                                                    </select>
                                                </td>
                                                <td><i
                                                    className="fa fa-check-circle text-success mr-2" /> {item.userStatus ? 'Active' : 'Inactive'}
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {list.length ? '' : <h5 className="text-center">Empty</h5>}
                            </div>
                        </Tab>

                        <Tab eventKey="2" title={('Active Subscribers')}>
                            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                                {loader ? <div className="loader_lg"><Loader /></div> : ''}
                                <table className="table user-table table-hover align-items-center">
                                    <col style={{ width: '3%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '17%' }} />
                                    <col style={{ width: '10%' }} />
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Name</th>
                                            <th onClick={() => handleFilterChange('created')} style={{ cursor: 'pointer' }}>
                                                Created {filterBy === 'created'}
                                            </th>
                                            <th>Company name</th>
                                            <th>Credits left</th>
                                            <th>Auto refill</th>
                                            <th>Show Credit</th>
                                            <th>Active Subscribers</th>
                                            <th>Mobile number</th>
                                            <th onClick={() => handleFilterChange('lastActive')} style={{ cursor: 'pointer' }}>
                                                Last Active {filterBy === 'lastActive'}
                                            </th>                                            
                                            <th>Cars created</th>
                                            <th>⁠Subscription Plan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((item, i) => (
                                            <tr key={item._id}>{
                                                console.log(item, "kjhgfdsasdfghj")
                                            }
                                                <td>{((i + 1) + ((page - 1) * limit))}</td>
                                                <td>
                                                    <Link to={`/userdetail/${item._id}`}>
                                                        <div className="d-inline-block align-middle">
                                                            <span className="font-weight-bold">{item.fullName}</span>
                                                            <div className="small text-gray">{item.email}</div>
                                                        </div>
                                                    </Link>
                                                </td>
                                                <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                                                {item.companyDetails ? <td>{item.companyDetails.companyName}</td> : item.companyName ?
                                                    <td>{item.companyName}</td> : <td>-</td>}
                                                {/* {item.companyDetails ?
                                                    <td>{item.companyDetails.suit}, {item.companyDetails.streetAddress}, {item.companyDetails.city}, {item.companyDetails.state}, {item.companyDetails.country} ({item.companyDetails.postalCode})</td> :
                                                    <td>-</td>} */}
                                                <td>{item.leftPackCredits ? item.leftPackCredits : 0}</td>

                                                <td><label class="switch">


                                                    <input type="checkbox" checked={item.thresholdRefillStatus == 1 ? true : false}
                                                        onChange={(e) => handleSelect(e, item._id, 2, item.thresholdRefillStatus)} />
                                                    <span class="slider round"></span>
                                                </label></td>
                                                {/* added this ui */}
                                                <td>
                                                    <label className="switch">

                                                        <input
                                                            type="checkbox"
                                                            checked={item.showCredit === true}  // Changed this line
                                                            onChange={(e) => handleSelect(e, item._id, 5, item.showCredit)}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                </td>

                                                <td><label class="switch">


                                                    <input type="checkbox" checked={item.isActiveSubscriber == 1 ? true : false} onChange={(e) => handleSelect(e, item._id, 4, item.isActiveSubscriber)} />
                                                    <span class="slider round"></span> </label></td>

                                                <td>
                                                    {item.countryCode ? item.countryCode : ''} {item.phoneNumber ? item.phoneNumber : ''}
                                                    {/*<i onClick={() => handleEdit(item)} className="fa fa-pencil cursorpointer" />*/}
                                                    {/*}
                                                    {item.couponId ? item.couponId : ' ADD   '}
                                                    {item.couponId ?
                                                        <i onClick={() => handleEdit(item)} className="fa fa-pencil cursorpointer" /> :
                                                        <i onClick={() => handleEdit(item)} className="fa fa-plus cursorpointer" />} */}
                                                </td>
                                                <td>
                                                    {item.lastActive ? <LastActive timestamp={item.lastActive} /> : ''}
                                                </td>

                                                <td>{item.carCount}</td>

                                                <td>
                                                    {item.subscriptionPlan ? item.subscriptionPlan : ''}
                                                    {/*
                                                    <i
                                                    className="fa fa-check-circle text-success mr-2" /> {item.userStatus ? 'Active' : 'Inactive'} */}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {list.length ? '' : <h5 className="text-center">Empty</h5>}
                            </div>
                        </Tab>
                    </Tabs>
                </div>

            </div>

            {
                console.log(pagination, "paginationpagination")
            }
            {pagination ? <Pagination
                totalRecords={pagination ? pagination.totalCount : '100'}
                pageLimit={limit}
                pageRangeDisplayed={5}
                onChangePage={page => setPage(page)}
            /> : ''}


            <Modal
                show={createModal}
                onHide={handleClose}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Coupon Name</label>

                            <input
                                className={`form-control ${couponIdErr ? 'is-invalid' : ''} rounded-pill`}
                                type="text"
                                maxLength={"40"}
                                value={couponId}
                                onChange={(e) => handleOnChange(e, currentId)}

                                placeholder="Enter coupon name" />
                            {/*//onChange={e => (setCouponId(e.target.value), setCouponIdErr(''))}*/}

                            {couponIdErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{couponIdErr}</Tooltip>}>
                                    <span className="error_tootltip" />
                                </OverlayTrigger> : ''}

                            <span className="error mt-4">
                                {couponIdErr ? couponIdErr : ''}</span>
                        </div>


                        <div className="text-center mt-3">
                            <button disabled={isDisabled || couponIdErr ? true : false} type="submit"
                                className="btn btn-primary rounded-pill pl-5 pr-5">Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Users;